<template>
    <b-modal v-model="show"
             size="lg"
             :header-bg-variant="modal_type"
             :header-text-variant="modal_title_text_color"
             hide-footer
             :no-enforce-focus="true"
             centered
             style="z-index:6099!important;"
             scrollable
             hide-backdrop
             visible
             @hidden="resetModal"
             :title="modal_title">
        <div v-html="modal_message"></div>
    </b-modal>
</template>

<script>
    export default {
        data() {
            return {
                show : true,
            };
        },
        props: {
            modal_title: {
                type: String,
                required: true,
                default: '',
            },
            modal_message: {
                type: String,
                required: true,
                default: '',
            },
            modal_type: {
                type: String,
                required: false,
                default: 'danger',
            },
            modal_title_text_color: {
                type: String,
                required: false,
                default: 'light',
            },
        },
        computed: {
        },
        methods: {
            resetModal() {
                this.$root.prompt_message_modal = false;
            }
        },
        computed: {
            lang() {
                return this.$store.getters.lang;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal/ModalMessage.vue